import { useAuth } from '@/contexts/AuthContext';
import { useIsFetching } from '@tanstack/react-query';
import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';

export function SyncIndicator() {
  const { roleLoading } = useAuth();
  const isFetching = useIsFetching();
  
  if (!roleLoading && isFetching === 0) return null;
  
  return (
    <div className="fixed top-4 right-4 z-50">
      <Badge variant="secondary" className="flex items-center gap-2">
        <Loader2 className="h-3 w-3 animate-spin" />
        <span className="text-xs">
          {roleLoading ? 'Carregando perfil...' : 'Sincronizando...'}
        </span>
      </Badge>
    </div>
  );
}
